import { isBrowser } from "@chatfood/core-utils";

// Matches `$breakpoint-sm` (app/assets/scss/variables.scss).
const MOBILE_BREAKPOINT_PX = 576;

export const useIsMobile = (): boolean =>
  isBrowser() && window.innerWidth <= MOBILE_BREAKPOINT_PX;
